import { createContext } from "react";

export const defaultValues = {
  concise: 5
};

export const DataValuesContext = createContext();
